import React from 'react';
import Slider from 'react-slick';
import './IndustriesSection.css';

// Import your new local images
import manufacturingImg from '../../assets/images/manufacturing.jpeg';
import bankingImg from '../../assets/images/banking.jpeg';
import automotiveImg from '../../assets/images/automotive.jpeg';
import retailImg from '../../assets/images/retail.jpeg';

// Import slick-carousel css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IndustriesSection = () => {
  const industries = [
    {
      name: 'MANUFACTURING',
      link: '/service/manufacturing/',
      image: manufacturingImg // Use imported image
    },
    {
      name: 'BANKING',
      link: '/service/banking/',
      image: bankingImg // Use imported image
    },
    {
      name: 'AUTOMOTIVE',
      link: '/service/automotive/',
      image: automotiveImg // Use imported image
    },
    {
      name: 'RETAIL',
      link: '/service/retail/',
      image: retailImg // Use imported image
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <section className="industries-section">
      <div className="container">
        <h2 className="section-title">SAP RELATED INDUSTRIES</h2>
        <p className="section-subtitle">
          At NeuroverseAI, we specialize in delivering comprehensive SAP solutions, including S/4 HANA, SuccessFactors, Concur, Ariba, Signavio, GRC, and BTP, to streamline processes and drive business transformation.
        </p>
        <div className="industries-slider">
          <Slider {...sliderSettings}>
            {industries.map((industry, index) => (
              <div key={index} className="industry-card-wrapper">
                <div className="industry-card">
                  <div className="card-image-container">
                    <img src={industry.image} alt={industry.name} className="card-image" />
                    <div className="card-overlay">
                      <a href={industry.link} className="card-button">View More</a>
                    </div>
                  </div>
                  <div className="card-content">
                    <h3 className="industry-name">
                      <a href={industry.link}>{industry.name}</a>
                    </h3>
                    <a href="/service-category/industries/" className="industry-category">Industries</a>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
